// extracted by mini-css-extract-plugin
module.exports = {"buttons":"FilterButtons_buttons__WFbYB","remove":"FilterButtons_remove__WDRnV","save":"FilterButtons_save__dBdjL","save-text":"FilterButtons_save-text__UNq58"};